import React from 'react';
import PropTypes from 'prop-types';

import ImmunotherapyAndNutritionIframe from '../ImmunotherapyAndNutritionIframe';
import OneDocIframe from '../OneDocIframe';

const IFRAME_INFO_TYPES = {
  FERTILITY_CONSULTATION: 'fertilityConsultation',
  IMMUNOTHERAPY_CONSULTATION: 'immunotherapyConsultation',
  IMMUNOTHERAPY_PREPARATORY_CONSULTATION:
    'immunotherapyPreparatoryConsultation',
  IMMUNOTHERAPY_FIRST_TIME_INTAKE_CONSULTATION:
    'immunotherapyFirstTimeIntakeConsultation',
  IMMUNOTHERAPY_CHECK_IN_CONSULTATION: 'immunotherapyCheckInConsultation',
  NUTRITION_ADVICE_NUTRITIONIST_CONSULTATION:
    'nutritionAdviceNutritionistConsultation',
};

const BookingIframe = (props) => {
  const { data, language } = props;
  const type = data?.info?.type;

  if (type === IFRAME_INFO_TYPES.FERTILITY_CONSULTATION) {
    return <OneDocIframe type={type} language={language} />;
  }

  if (type === IFRAME_INFO_TYPES.IMMUNOTHERAPY_CONSULTATION) {
    return <ImmunotherapyAndNutritionIframe {...props} type={type} />;
  }

  if (type === IFRAME_INFO_TYPES.IMMUNOTHERAPY_PREPARATORY_CONSULTATION) {
    return <ImmunotherapyAndNutritionIframe {...props} type={type} />;
  }

  if (type === IFRAME_INFO_TYPES.IMMUNOTHERAPY_FIRST_TIME_INTAKE_CONSULTATION) {
    return <ImmunotherapyAndNutritionIframe {...props} type={type} />;
  }

  if (type === IFRAME_INFO_TYPES.IMMUNOTHERAPY_CHECK_IN_CONSULTATION) {
    return <ImmunotherapyAndNutritionIframe {...props} type={type} />;
  }

  if (type === IFRAME_INFO_TYPES.NUTRITION_ADVICE_NUTRITIONIST_CONSULTATION) {
    return <ImmunotherapyAndNutritionIframe {...props} type={type} />;
  }

  return null;
};

BookingIframe.propTypes = {
  dispatch: PropTypes.func,
  conversationFlowStateKey: PropTypes.string,
  conversationId: PropTypes.string,
  userData: PropTypes.object,
  dataLoading: PropTypes.bool,
  data: PropTypes.shape({
    info: PropTypes.shape({
      type: PropTypes.string,
    }),
  }),
  language: PropTypes.string,
  testCode: PropTypes.string,
};

export default BookingIframe;
